var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C3.15913 0 3.31174 0.0632142 3.42426 0.175736C3.53679 0.288258 3.6 0.44087 3.6 0.6V2.4H5.4C5.55913 2.4 5.71174 2.46321 5.82426 2.57574C5.93679 2.68826 6 2.84087 6 3C6 3.15913 5.93679 3.31174 5.82426 3.42426C5.71174 3.53679 5.55913 3.6 5.4 3.6H3.6V5.4C3.6 5.55913 3.53679 5.71174 3.42426 5.82426C3.31174 5.93679 3.15913 6 3 6C2.84087 6 2.68826 5.93679 2.57574 5.82426C2.46321 5.71174 2.4 5.55913 2.4 5.4V3.6H0.6C0.44087 3.6 0.288258 3.53679 0.175736 3.42426C0.0632142 3.31174 0 3.15913 0 3C0 2.84087 0.0632142 2.68826 0.175736 2.57574C0.288258 2.46321 0.44087 2.4 0.6 2.4H2.4V0.6C2.4 0.44087 2.46321 0.288258 2.57574 0.175736C2.68826 0.0632142 2.84087 0 3 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/WhitePlus.05f17a873fb38210e337323aba2ccd02.svg";
export { ForwardRef as ReactComponent };